// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("bootstrap/dist/js/bootstrap")
require("moment")
require("bootstrap-colorpicker")
require("bootstrap-daterangepicker")
require("jquery")
require("chartkick")
require("chart.js")
require("@stripe/stripe-js")


import $ from 'jquery'
import Prism from 'prismjs'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "controllers"

import "../utils/modals"
import "../utils/jquery_event_delegator"
import "../utils/other"

window.jQuery = $;
window.$ = $;

import moment from 'moment';
window.moment = moment;
require("tempusdominus-bootstrap-4")

// Global AJAX handler for redirects
document.addEventListener('ajax:success', function(event) {
  const [data, status, xhr] = event.detail;
  if (data && data.redirect_url) {
    window.location.href = data.redirect_url;
  }
});

document.addEventListener('ajax:error', function(event) {
  const [data, status, xhr] = event.detail;
  if (data && data.redirect_url) {
    window.location.href = data.redirect_url;
  }
});

